export default theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
})
